
export const appName = 'Maritime Checklist';

export const signInUrl = '#login';

export const signOutUrl = '#logout';

export const mainLinks = [
  { to: '/home', text: 'Home', authRequired: false },
  { to: '/templates', text: 'Templates', authRequired: true },
  { to: '/checklists', text: 'Checklists', authRequired: true }
];
